/* eslint-disable sort-keys */
/* eslint-disable max-len */
/**
 * BSD Zero Clause License
 *
 * Copyright (c) 2021 Brion Mario
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
 * REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
 * AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
 * INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
 * LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
 * OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
 * PERFORMANCE OF THIS SOFTWARE.
 */
import { PageProps } from "gatsby";
import React, { FunctionComponent, ReactElement } from "react";
import { Helmet } from "react-helmet";
import settings from "../../contents/settings.json";
import { SEO, ServicesView, SiteLayout, TasFollowButtons, TasShareButtons } from "../components";
import { TestableComponentInterface } from "../models";


/**
 * Interface for the Index Page props.
 */
type IIndexPageProps = TestableComponentInterface;

/**
 * Home page of the site.
 *
 * @param {PageProps<IIndexPageProps>} props - Props injected to the component.
 * @return {React.ReactElement}
 */
const IndexPage: FunctionComponent<PageProps<IIndexPageProps>> = (
    props: PageProps<IIndexPageProps>
): ReactElement => {

    const {
        data
    } = props;

    const {
        "data-testid": testId
    } = data;
    const { services } = settings;
    const desc = services != null && services.meta != null ? services.meta.desc : "Professional car detailing center in Thiruvananthapuram, with wide range of services including Snow foam car wash, bike wash, car and bike detailing, nano ceramic coating, graphene coating, wax, bullet polish, glass repair, watermarks removal, polishing etc";
    const keywords = services != null && services.meta != null ? services.meta.keywords : "Best car detailing | Polishing Trivandrum";
    const title = services != null && services.meta != null ? services.meta.title : "Services :: T.A.S (Travancore Auto Spa) Detailing Studio : Thiruvananthapuram, Car care";

    return (
        <SiteLayout data-testid={ `${testId}-site-layout` }>  
            <Helmet>   
                { (desc) &&
                    <meta name="description" content={ desc } />
                }
                { (keywords) &&
                    <meta name="keywords" content={ keywords } />
                }
               
                { /* <!-- Open Graph / Facebook --> */ }
                <meta property="og:type" content="website" />
                <meta property="og:url" content="http://tasstudio.in/services" />
                <meta property="og:title" content={ title } />
                <meta property="og:description" content={ desc } />
    
                { /* <!-- Twitter --> */ }
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content="http://tasstudio.in/services" />
                <meta property="twitter:title" content={ title } />
                <meta property="twitter:description" content={ desc } />
    
    
            </Helmet> 
            <SEO title={ title }  />

            <TasShareButtons/>           
            <ServicesView count={ -1 }/>
            <TasFollowButtons/>
        </SiteLayout>
    );
};

/**
 * Default props for the component.
 * @type {{data: {"data-testid": string}}}
 */
IndexPage.defaultProps = {
    data: {
        "data-testid": "index-page"
    }
};

export default IndexPage;
